import './index.css'
import { useState } from 'react'
import { useAuth } from './lib/AuthContext'
import Login from './pages/Login'
import Layout from './components/Layout'
import Accesos from './pages/Accesos'
import Gremios from './pages/Gremios'
import Paquetes from './pages/Paquetes'
import Retiros from './pages/Retiros'
import Reclamos from './pages/Reclamos'
import Difusiones from './pages/Difusiones'
import Directorio from './pages/Directorio'
import Historial from './pages/Historial'
import Oficinas from './pages/Oficinas'
import Usuarios from './pages/Usuarios'
import SalasReuniones from './pages/SalasReuniones'
import Novedades from './pages/Novedades'
import Dashboard from './pages/Dashboard'
import RetirarPaquete from './pages/RetirarPaquete'

// Ruta pública: /retirar/:token
const retiroMatch = window.location.pathname.match(/^\/retirar\/([a-f0-9-]{36})$/)
if (retiroMatch) {
  const token = retiroMatch[1]
  const root = document.getElementById('root')
  import('react-dom/client').then(({ createRoot }) => {
    createRoot(root).render(<RetirarPaquete token={token} />)
  })
}

export default function App() {
  const { user, usuario, loading } = useAuth()
  const [page, setPage] = useState('accesos')

  // Si estamos en ruta pública de retiro, no renderizar la app
  if (retiroMatch) return null

  if (loading) {
    return (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'var(--bg)', flexDirection: 'column', gap: 16 }}>
        <div style={{ width: 48, height: 48, borderRadius: 12, background: 'var(--gold-dim)', border: '1.5px solid var(--gold)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 24 }}>🏛</div>
        <div style={{ color: 'var(--text3)', fontFamily: 'DM Mono, monospace', fontSize: 12, letterSpacing: 1 }}>CARGANDO...</div>
      </div>
    )
  }

  if (!user || !usuario) return <Login />

  const renderPage = () => {
    switch (page) {
      case 'accesos': return <Accesos />
      case 'gremios': return <Gremios />
      case 'paquetes': return <Paquetes />
      case 'retiros': return <Retiros usuario={usuario} />
      case 'reclamos': return <Reclamos />
      case 'difusiones': return <Difusiones />
      case 'directorio': return <Directorio />
      case 'historial': return <Historial />
      case 'oficinas': return <Oficinas />
      case 'dashboard': return <Dashboard />
      case 'novedades': return <Novedades usuario={usuario} />
      case 'salas': return <SalasReuniones usuario={usuario} />
      case 'usuarios': return usuario?.rol === 'admin' ? <Usuarios /> : <Accesos />
      default: return <Accesos />
    }
  }

  return <Layout currentPage={page} onNavigate={setPage}>{renderPage()}</Layout>
}
